import { api } from "../utils/AuthManager";
const GetAnomaly = async () => {
  return api
    .get(`/api/anomaly/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAnomaly;
